/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Placeflyerslanguage2Inputs */

const en_placeflyerslanguage2 = /** @type {(inputs: Placeflyerslanguage2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Language`)
};

const de_placeflyerslanguage2 = /** @type {(inputs: Placeflyerslanguage2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sprache`)
};

/**
* | output |
* | --- |
* | "Language" |
*
* @param {Placeflyerslanguage2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const placeflyerslanguage2 = /** @type {((inputs?: Placeflyerslanguage2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Placeflyerslanguage2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_placeflyerslanguage2(inputs)
	return de_placeflyerslanguage2(inputs)
});
export { placeflyerslanguage2 as "placeFlyersLanguage" }